// extracted by mini-css-extract-plugin
export default {"banner0":"home_banner0__Skwl-","banner1":"home_banner1__VBPVC","banner2":"home_banner2__7bjak","banner3":"home_banner3__il7gU","pageTitle":"home_pageTitle__GLOT9"};